import { createContext, useContext } from 'react';

/** Открытие боковой панели на узком экране (кнопка-гамбургер в шапке страницы). */
export const NavContext = createContext<{ openNav: () => void }>({ openNav: () => undefined });

export function useNav() {
  return useContext(NavContext);
}
